import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mTextEllipsis'
})
export class MTextEllipsisPipe implements PipeTransform {
  transform(value: string, length: number = 25, splitIndex: number = 2): string {
    if (typeof value !== 'string') {
      return value;
    }
    if (value.length < length) {
      return value;
    }
    const prefix = value.substring(0, value.length / splitIndex - 1);
    const suffix = value.substring(value.length - value.length / splitIndex + 1, value.length);
    return `${prefix}...${suffix}`;
  }
}
